<script setup lang="ts">
import useLocale from '../composables/useLocale';

const { t } = useLocale();

defineProps<{
  roundedClass?: string;
}>();

const emit = defineEmits<{
  (e: 'on-create-collection'): void;
}>();

const handleCreateShelf = () => {
  emit('on-create-collection');
};
</script>

<template>
  <v-btn
    variant="flat"
    color="primary"
    class="text-none create-collection-btn"
    :class="[roundedClass || '']"
    @click="handleCreateShelf"
  >
    <slot name="prepend-icon">
      <v-icon>mdi-plus</v-icon>
    </slot>
    {{ t('content_collections.button_new_collection') }}
  </v-btn>
</template>

<style scoped lang="scss">
.create-collection-btn {
  letter-spacing: 0;
}
</style>
